import {Button, Card, CardHeader} from "@mui/material"
import Grid from "@mui/material/Grid"
import {GreenCheckIconV2, ReoccurringDollarIcon} from "@indebted/assets"
import {paletteColors} from "@indebted/theme"
import {useNavigate} from "react-router-dom"

import {nextPage} from "../Navigator"

import {
	CardContentLessPadding,
	CardHeadingTypography,
	ColoredTypography,
	ColoredTypographyWithBottomMargin,
	GridWithBottomMargin,
	StyledDiv,
} from "./styles"

const PaymentSuccessfulPage = ({
	paymentArrangementID,
	I18n,
	Next,
	InstalmentAmount,
}: {
	paymentArrangementID: string
	I18n: {
		Title: string
		Subtitle: string
		PaymentDetailsCardTitle: string
		PaymentDetailsCardPaymentAmountLabel: string
		ButtonText: string
	}
	Next: string
	InstalmentAmount: string
}) => {
	const navigate = useNavigate()
	return (
		<Grid container direction="column" alignItems="center" justifyContent="center">
			<Grid container direction="row" alignItems="center" justifyContent="center" style={{marginTop: "25px"}}>
				<GreenCheckIconV2 />
			</Grid>
			<Grid container direction="row" alignItems="center" justifyContent="center" style={{marginBottom: "10px"}}>
				<ColoredTypographyWithBottomMargin
					variant="h5"
					color={paletteColors.stratosLight2}
					align="center"
					style={{padding: "0 64px", fontWeight: 700, lineHeight: "28px"}}
				>
					{I18n.Title}
				</ColoredTypographyWithBottomMargin>
			</Grid>
			<Grid container direction="row" alignItems="center" justifyContent="center" style={{marginBottom: "34px"}}>
				<ColoredTypographyWithBottomMargin
					variant="subtitle1"
					color={paletteColors.stratos}
					align="center"
					style={{padding: "0 64px", lineHeight: "22px"}}
				>
					{I18n.Subtitle}
				</ColoredTypographyWithBottomMargin>
			</Grid>

			<Grid
				container
				direction="row"
				alignItems="center"
				justifyContent="center"
				style={{padding: "10px 20px", marginBottom: "35px"}}
			>
				<Card
					style={{
						width: "100%",
						marginBottom: "20px",
						boxShadow: "0px 11px 22px 0px rgba(25,89,135,0.2)",
						background: "#fafafa",
					}}
				>
					<CardHeader
						title={
							<CardHeadingTypography color={paletteColors.stratos}>
								{I18n.PaymentDetailsCardTitle}
							</CardHeadingTypography>
						}
					/>
					<CardContentLessPadding>
						<GridWithBottomMargin container direction="row" justifyContent="space-between">
							<StyledDiv>
								<ColoredTypography variant="subtitle1" color={paletteColors.stratosLight2}>
									{I18n.PaymentDetailsCardPaymentAmountLabel} {InstalmentAmount}
								</ColoredTypography>
							</StyledDiv>
						</GridWithBottomMargin>
					</CardContentLessPadding>
				</Card>
			</Grid>

			<Button
				style={{borderRadius: "35px", padding: "6px 30px", marginTop: "10px"}}
				type="button"
				onClick={() => navigate(nextPage(Next, paymentArrangementID))}
				variant="contained"
				startIcon={<ReoccurringDollarIcon />}
			>
				{I18n.ButtonText}
			</Button>
		</Grid>
	)
}

export {PaymentSuccessfulPage}
